import { generateJsonWebToken, checkAndGetSessionStorageValue } from "../../../features/utils";
export async function submitTriageSymptoms({ state, actions},lang ) {

  const { currentSymptomsMap, triageRequest } = state // See ./symptom
  const { sessionId } = triageRequest

  let { primarySymptom } = state
  let symptomText = (primarySymptom && currentSymptomsMap[primarySymptom]
      && currentSymptomsMap[primarySymptom].common_name) || ''
  const secondarySymptoms = []

  for (const key of Object.keys(currentSymptomsMap)) {

      const { common_name = '', id } = currentSymptomsMap[key]

    if (!primarySymptom) {
      primarySymptom = id
        symptomText = common_name
      continue
    }

    secondarySymptoms.push(id)
  }
  const encounterToken = localStorage.getItem('token')
  var jwtAccess_Token = generateJsonWebToken()
  var access_Token = checkAndGetSessionStorageValue("accessToken")
  const data = {
    identifier: sessionId,
    languageId:actions.getLanguage(lang),
      symptomText,
      presentSymptoms: state.currentSymptomsSortedKeys,
      encounterToken,
      jwtAccessToken : jwtAccess_Token,
      accessToken : access_Token,
     AbsentSymptoms: []
  }

  console.log('submitTriageSymptoms', data)

  await actions.sendTriageRequest({ action: 'submitSymptoms', data })
}
function switchResult(selectedCareOptionName ){
  switch(selectedCareOptionName) {
      case 'House Visit':
            return 1;
      case 'Clinic':
          return 2;
      case 'Retail Clinic':
        return 5;
        case 'Urgent Care':
          return 3;
        case 'Emergency Room':
        return 4;
       
      default:
        return 0;
    }
}

export async function addEmergencyAnswers({state, actions}){
  const { triageRequest } = state
    const { sessionId,selectedCareOptionName } = triageRequest
    var jwtAccess_Token = generateJsonWebToken()
    var access_Token = checkAndGetSessionStorageValue("accessToken")
    const encounterToken = localStorage.getItem('token')
    const data={
      identifier: sessionId,
      token: encounterToken,
      jwtAccessToken : jwtAccess_Token,
      accessToken : access_Token,
    }
    await actions.sendTriageRequest({actions: "addEmergencyAnswer" , data})
}

export async function submitTriageHouseVisit({ state, actions, valuedata }) {
    const { triageRequest } = state
    const { sessionId} = triageRequest
    var jwtAccess_Token = generateJsonWebToken()
    var access_Token = checkAndGetSessionStorageValue("accessToken")
    const encounterToken = localStorage.getItem('token')
    let coordinationType= switchResult(localStorage.getItem('careoption'))
    { valuedata.hasOwnProperty('hotelname') ? "" : valuedata.hotelname = "" }
    { valuedata.hasOwnProperty('roomnumber') ? "" : valuedata.roomnumber = "" }    
    const data = {
        identifier: sessionId,
        coordinationType:coordinationType,
        token: encounterToken,
        locationType: valuedata.locationType,
        hotelName: valuedata.hotelname,
        hotelRegisteredTo: "",
        hotelPhone: valuedata.phone,
        address: valuedata.location,
        roomNumber: valuedata.roomnumber,
        serviceAddress: "",
        comments: valuedata.comments,
        unit: "",
        country:state.triageRequest.country,
        state: state.triageRequest.province,
        city: state.triageRequest.city,
        extension: state.triageRequest.data.extensionOrRoomNumber,
        userContact: state.triageRequest.userContact,
        insuranceCarrier: state.triageRequest.data.insurance,
        policy: state.triageRequest.data.policyNum,
        travelDateEffectFrom : state.triageRequest.data.effectFrom,
        travelDateEffectTo : state.triageRequest.data.effectTo,
        primaryInsuredName: state.triageRequest.data.insuredOn,
        insuredBirthDate: state.triageRequest.InsuredBirthday,
        insuredGender: state.triageRequest.data.sex,
        insuredRelation: state.triageRequest.data.relation, 
        jwtAccessToken : jwtAccess_Token,
        accessToken : access_Token,
       
    }

    await actions.sendTriageRequest({ action: 'submitHouseVisit', data })
}